export enum ProductUnitReturnablePackageDepositField {
    Amount = 1,
    ProductUnit = 2,
    DepositType = 3
}

(ProductUnitReturnablePackageDepositField as any).__typeName = 'ProductUnitReturnablePackageDepositField';

